import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { OneModal } from '@factorialco/f0-react/dist/experimental'
import type { ComplaintsCategoriesQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  category: ComplaintsCategoriesQuery['complaints']['categoriesConnection']['nodes'][0] | null
  open: boolean
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}

export const DeleteCategoryModal = ({
  category,
  open,
  onClose,
  onConfirm,
  loading = false,
}: Props) => {
  if (!category) return null

  return (
    <OneModal isOpen={open} onClose={onClose}>
      <OneModal.Header
        title={i18n.t('app_store_v2.apps.complaints.settings.categories.delete_modal.title')}
      />
      <OneModal.Content withPadding>
        <Box gap="s12">
          <Text.Normal>
            {i18n.t('app_store_v2.apps.complaints.settings.categories.delete_modal.message', {
              categoryName: category.name,
            })}
          </Text.Normal>
        </Box>
      </OneModal.Content>
      <OneModal.Footer>
        <div className="flex flex-row gap-2 justify-end w-full">
          <F0Button
            onClick={onClose}
            label={i18n.t('app_store_v2.apps.complaints.settings.categories.delete_modal.cancel')}
            variant="outline"
            disabled={loading}
          />
          <F0Button
            onClick={onConfirm}
            label={
              loading
                ? i18n.t('app_store_v2.apps.complaints.settings.categories.delete_modal.deleting')
                : i18n.t('app_store_v2.apps.complaints.settings.categories.delete_modal.delete')
            }
            variant="default"
            disabled={loading}
            loading={loading}
          />
        </div>
      </OneModal.Footer>
    </OneModal>
  )
}
